import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const stage = createTaskFilterFunction('stage', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  // @ts-ignore
  return filters.stage !== undefined && filters.stage?.includes(task.stage)
})
